(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.blogFilterInitialized) return;
  window.blogFilterInitialized = true;
  
  var FILTER_KEY = 'blog_active_categories';
  
  // Get article cards
  function getArticleCards() {
    var blogList = document.querySelector('.blg-Blog .art-List_Items');
    if (!blogList) return [];
    return Array.from(blogList.querySelectorAll('[data-blog-article]'));
  }
  
  // Get categories from sessionStorage (URL is not updated on filter change)
  function getCategories() {
    try {
      var stored = sessionStorage.getItem(FILTER_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {}
    return [];
  }
  
  // Save selected categories
  function saveSelectedCategories(categories) {
    sessionStorage.setItem(FILTER_KEY, JSON.stringify(categories));
  }
  
  // Check if article has a tag matching the category (handles pipe-separated tags)
  function articleHasMatchingTag(articleTags, catClean, isHowTo) {
    var tags = (articleTags || '').split('|').map(function(t) { return t.trim().toLowerCase(); });
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (!t) continue;
      if (isHowTo) {
        if (t.indexOf('how to') !== -1) return true;
      } else {
        var catSpace = catClean.replace(/-/g, ' ');
        if (t === catClean || t === catSpace || t === 'category:' + catClean || t === 'category: ' + catSpace ||
            t === 'category-' + catClean || t === 'roomtype-' + catClean) return true;
      }
    }
    return false;
  }

  // Check if article matches categories
  function articleMatchesCategories(card, categories) {
    if (categories.length === 0) return true;
    
    var articleTags = card.dataset.articleTags || '';
    
    for (var i = 0; i < categories.length; i++) {
      var cat = categories[i].toLowerCase();
      var catClean = cat.replace('category-', '').replace('roomtype-', '');
      var isHowTo = (catClean === 'how-to' || cat === 'category-how-to');
      
      if (articleHasMatchingTag(articleTags, catClean, isHowTo)) return true;
    }
    return false;
  }
  
  // Filter visible articles
  function filterArticles(categories) {
    var cards = getArticleCards();
    var visibleCount = 0;
    
    cards.forEach(function(card) {
      if (categories.length === 0 || articleMatchesCategories(card, categories)) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });
    
    var loadMoreContainer = document.querySelector('.blg-LoadMore');
    if (loadMoreContainer) {
      loadMoreContainer.style.display = categories.length > 0 ? 'none' : '';
    }
    
    return visibleCount;
  }
  
  // Update filter button UI
  function updateFilterUI(categories) {
    var allLinks = document.querySelectorAll('.js-category-all');
    var filterLinks = document.querySelectorAll('.js-category-filter');
    
    allLinks.forEach(function(allLink) {
      if (categories.length === 0) {
        allLink.classList.add('blg-Navigation_Link-active');
        allLink.setAttribute('aria-current', 'true');
      } else {
        allLink.classList.remove('blg-Navigation_Link-active');
        allLink.removeAttribute('aria-current');
      }
    });
    
    filterLinks.forEach(function(link) {
      var category = link.getAttribute('data-category');
      if (category && categories.indexOf(category) > -1) {
        link.classList.add('blg-Navigation_Link-active');
        link.setAttribute('aria-current', 'true');
      } else {
        link.classList.remove('blg-Navigation_Link-active');
        link.removeAttribute('aria-current');
      }
    });
  }
  
  // Handle click on filter links using event delegation
  function handleFilterClick(e) {
    var target = e.target;
    
    // Find the closest filter link
    var allLink = target.closest('.js-category-all');
    var filterLink = target.closest('.js-category-filter');
    
    if (allLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      saveSelectedCategories([]);
      updateFilterUI([]);
      filterArticles([]);
      return false;
    }
    
    if (filterLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      var category = filterLink.getAttribute('data-category');
      if (!category) return;
      
      var categories = getCategories();
      var index = categories.indexOf(category);
      
      if (index > -1) {
        categories.splice(index, 1);
      } else {
        categories.push(category);
      }
      
      saveSelectedCategories(categories);
      updateFilterUI(categories);
      filterArticles(categories);
      return false;
    }
  }

  // Initialize filtering
  function initFiltering() {
    var currentCategories = getCategories();
    updateFilterUI(currentCategories);
    filterArticles(currentCategories);
    document.addEventListener('click', handleFilterClick, true);
  }

  // Re-apply filter when new articles are loaded dynamically
  document.addEventListener('blog:articlesAdded', function() {
    var categories = getCategories();
    if (categories.length > 0) {
      filterArticles(categories);
    }
  });

  initFiltering();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateFilterUI(getCategories());
      filterArticles(getCategories());
    });
  }
})();
